import {
  backButton,
  viewport,
  themeParams,
  miniApp,
  initData,
  $debug,
  init as initSDK, mountSwipeBehavior, mainButton, enableVerticalSwipes, secondaryButton,
} from '@telegram-apps/sdk-react';
import { initI18n } from "@/helpers/translate/i18n.ts";

/**
 * Initializes the application and configures its dependencies.
 */
export async function init(debug: boolean): Promise<void> {
  // Set @telegram-apps/sdk-react debug mode.
  $debug.set(debug);

  // Initialize special event handlers for Telegram Desktop, Android, iOS, etc.
  // Also, configure the package.
  initSDK();

  // Add Eruda if needed.
  if (debug) {
    import('eruda')
      .then((lib) => lib.default.init())
      .catch(console.error);
  }

  // Check if all required components are supported.
  if (!backButton.isSupported() || !miniApp.isSupported()) {
    throw new Error('ERR_NOT_SUPPORTED');
  }

  // Mount all components used in the project.
  backButton.mount();
  miniApp.mount();
  mainButton.mount();

  await initI18n();

  if (secondaryButton.isSupported()) {
    secondaryButton.mount();
  }
  themeParams.mount();
  initData.restore();
  void viewport
    .mount()
    .catch(e => {
      console.error('Something went wrong mounting the viewport', e);
    })
    .then(() => {
      viewport.bindCssVars();
    });

  // Define components-related CSS variables.
  miniApp.bindCssVars();
  themeParams.bindCssVars();

  try {
    mountSwipeBehavior();
    enableVerticalSwipes();
  } catch (e) {
    console.error('Vertical swipes are not supported');
  }
}
